import React, { Component } from "react";

import GeneralInformationRenderer from "./GeneralInformationRenderer";
import UpcomingRenderer from "./UpcomingRenderer";
import StatusRenderer from "./StatusRenderer";
import ActionsRenderer from "./ActionsRenderer";

import JSONTree from "react-json-tree";
import PropTypes from "prop-types";

import LoanNotes from "../../../../components/loan/notes/LoanNotes";

export default class LoanDetails extends Component {
  constructor(props) {
    super(props);

    this.state = { removeOption: "", byType: "", date: new Date() };
  }

  componentDidMount() {
    // This means loan isn't payed out. No need to fetch any data (which will fail anyways)
    if (this.props.item.IssueDate == null) return;

    this.props.getLoanDetails(this.props.item.Id, this.props.accountId);

    this.props.getAccountInfoForId(this.props.item.BorrowerId);

    if (!this.props.adHocDataPending[this.props.item.Id]) {
      this.props.getAdHocDataPendingForId(this.props.item.Id);
    }

    if (!this.props.adHocDataComplete[this.props.item.Id]) {
      this.props.getAdHocDataCompleteForId(this.props.item.Id);
    }
  }

  changeRemoveOption = (event) => {
    this.setState({
      removeOption: event.target.value,
    });
  };

  changeDate = (value) => {
    this.setState({
      date: value,
    });
  };

  changeByType = (event) => {
    this.setState({
      byType: event.target.value,
    });
  };

  render() {
    let rowStyle = {
      maxHeight: "700px",
      overflow: "auto",
      display: "inline-block",
      padding: "0 15px",
      verticalAlign: "top",
      borderRight: "solid 1px #9f9f9f",
    };
    let item = this.props.item;

    return (
      <div>
        <div style={{ maxHeight: "700px", display: "flex" }}>
          <div style={rowStyle}>
            <GeneralInformationRenderer item={item} />
          </div>
          {this.props.item.IssueDate && (
            <React.Fragment>
              <div style={rowStyle}>
                <UpcomingRenderer
                  item={item}
                  pending={this.props.adHocDataPending[this.props.item.Id]}
                  completed={this.props.adHocDataComplete[this.props.item.Id]}
                />
              </div>
              <div style={rowStyle}>
                <StatusRenderer item={item} />
              </div>
              <div style={rowStyle}>
                <ActionsRenderer
                  {...this.props}
                  item={item}
                  callback={this.callback}
                />
              </div>
            </React.Fragment>
          )}
        </div>
        <LoanNotes loanId={this.props.item.Id} />
        <JSONTree hideRoot={true} data={this.props.item} />
      </div>
    );
  }

  callback = () => {
    this.props.getLoanDetails(this.props.item.Id, this.props.accountId);

    this.props.getAccountInfoForId(this.props.item.AccountId);

    if (!this.props.adHocDataPending[this.props.item.Id]) {
      this.props.getAdHocDataPendingForId(this.props.item.Id);
    }

    if (!this.props.adHocDataComplete[this.props.item.Id]) {
      this.props.getAdHocDataCompleteForId(this.props.item.Id);
    }
  };

  static propTypes = {
    accountInfos: PropTypes.object,
    item: PropTypes.object,
    adHocDataComplete: PropTypes.object,
    adHocDataPending: PropTypes.object,

    removeFees: PropTypes.func,
    getAccountInfoForId: PropTypes.func,
    getAdHocDataPendingForId: PropTypes.func,
    getAdHocDataCompleteForId: PropTypes.func,
    updateLoanStatus: PropTypes.func,

    addToDCAProcess: PropTypes.func,
    closeDCAProcess: PropTypes.func,
    addDCAMonthlyRepayment: PropTypes.func,
  };
}
